module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/bc147ee8750d399b4cdd4659713d68d3.png";